/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page_banner[_ngcontent-%COMP%]{background:url(/assets/images/bi.jpg) center center no-repeat #333;position:relative}.headings[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{color:#737373}h5.section_sub_heading[_ngcontent-%COMP%]{color:#737373;margin:0;padding:30px 0 20px;font-size:28px;font-weight:700}\n/*# sourceMappingURL=quem-somos.component.css.map*/"];
export { styles as styles };
